import { useHistory } from 'react-router-dom'
import Select from 'react-select';
export const AddTracking = () => {
    const history = useHistory()
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                        <div className="row">
                                    <div className="mb-3 col-6">
                                    <label className="form-label">Job No.</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Job No. "
                                    />
                                </div>
                        <div className="mb-3 col-6">
                                    <label className="form-label">Customer Name</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Customer Name "
                                    />
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                <label className="form-label">Shipment Status</label>
                                <Select>
                                <option>Select Status</option>
                                                        <option>Pick Up Arranged  </option>
                                                        <option>Shipment Departed</option>
                                                        <option>Shipment Arrived at Destination</option>
                                                        <option>Customs Cleared </option>
                                                        <option> Shipment Delivered </option>
                                </Select>
                            </div>
                            <div className="mb-3 col-6">
                                    <label className="form-label">Status Bar</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Add Status Bar"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Expected Delivery Date</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Expected Delivery Date "
                                        type="date"
                                    />
                                </div>
                                </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() =>console.log("fdgfdg")}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
